module.exports = __webpack_public_path__ + "static/media/mobile_leaderboard_preview.4fc321ea.svg";